/**
 * @graphql cc
 */
import { useQueryInterop } from '@confluence/apollo-relay-interop';
import gql from 'graphql-tag';

import { type CommentButtonQuery as CommentButtonQueryType } from './__types__/CommentButtonQuery';

export const CommentButtonQuery =
	// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Experimental Schema GraphQL Operation
	gql`
		query CommentButtonQuery($pageId: ID!) {
			comments(pageId: $pageId, type: UNRESOLVED, depth: ALL) {
				count
				nodes {
					id
					location {
						type
						... on InlineComment {
							inlineMarkerRef
						}
					}
				}
			}
			content(id: $pageId) {
				nodes {
					id
					properties(key: "editor") {
						nodes {
							id
							key
							value
						}
					}
					metadata {
						frontend {
							fabricEditorSupported
						}
					}
				}
			}
		}
	`;

export const usePreloadCommentButton = (contentId: string, isCommentButtonSSRd: boolean) => {
	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data: commentData, error: commentError } = useQueryInterop<CommentButtonQueryType>(
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
		CommentButtonQuery,
		{
			fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
			variables: { pageId: contentId },
		},
	);

	return {
		data: { commentData },
		error: commentError,
	};
};
